// extracted by mini-css-extract-plugin
module.exports = {"postThumbnail":"cj_nj","postThumbnail__image":"cj_nk","postThumbnail_gradient_bottom":"cj_nl","postThumbnail_gradient_left":"cj_nm","postThumbnail_gradient_right":"cj_nn"};